export default __webpack_public_path__ + "static/media/ricrac_type.460f560d.jpg";